import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { AppBaseService } from 'projects/lib/medcare-core-lib/src/lib/services/http.service';
import { OPD_API_URL } from 'projects/opd-medcare/src/app/properties/opd-url-properties';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-appoinment-patient-history-dialog-component',
  templateUrl: './appoinment-patient-history-dialog-component.component.html',
  styleUrl: './appoinment-patient-history-dialog-component.component.scss'
})
export class AppoinmentPatientHistoryDialogComponentComponent implements OnInit, OnDestroy {
  private subscriptionList = new Subscription();

  appointmentColumns: string[] = ['appointmentDate', 'department', 'doctor', 'appointmentType', 'teleconsultationType', 'category'];
  appointmentDataSource = new MatTableDataSource<any>();

  medicationColumns: string[] = ['medicationDate', 'drugName', 'quantity', 'drugLable', 'doctor', 'route', 'uomUnit', 'instruction'];
  medicationDataSource = new MatTableDataSource<any>();

  historyData: any;
  appointments: any[] = [];
  medications: any[] = [];

  constructor(
    public dialogRef: MatDialogRef<AppoinmentPatientHistoryDialogComponentComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private appBaseService: AppBaseService
  ) { }

  ngOnInit(): void {
    this.getPatientHistory();
  }

  getPatientHistory() {

    const mrn = this.data.mrn;

    this.appBaseService.setResourceURL(OPD_API_URL.PATIENT_INTEGRATOION);
    this.subscriptionList.add(
      this.appBaseService
        .getResource(OPD_API_URL.APPOINMENT_PATIENT_HISTORY + mrn)
        .subscribe({
          next: (res: any) => {
            this.historyData = res;
            this.appointments = res?.appointments || [];
            this.appointmentDataSource = new MatTableDataSource(this.appointments);
            this.medications = res?.medications || [];
            this.medicationDataSource = new MatTableDataSource(this.medications);

          },
          error: (err) => {
            console.error(err);
          }
        })
    );
  }

  close() {
    this.dialogRef.close();
  }

  ngOnDestroy(): void {
    this.subscriptionList.unsubscribe();
  }

}
